const pad = (value: number, width = 2): string =>
  value.toLocaleString("en", {
    minimumIntegerDigits: width,
    useGrouping: false,
  });

export interface CountdownParts {
  days: string;
  hours: string;
  minutes: string;
}

/** Days, hours, and whole minutes remaining until the deadline. */
export const countdownParts = (deadline: Date, now: Date): CountdownParts => {
  const totalMinutes = Math.max(
    0,
    Math.floor((deadline.getTime() - now.getTime()) / 60_000),
  );
  return {
    days: pad(Math.floor(totalMinutes / (60 * 24))),
    hours: pad(Math.floor(totalMinutes / 60) % 24),
    minutes: pad(totalMinutes % 60),
  };
};
